import { render } from "./NavbarItems.vue?vue&type=template&id=2139ae97&scoped=true"
import script from "./NavbarItems.vue?vue&type=script&lang=js"
export * from "./NavbarItems.vue?vue&type=script&lang=js"

import "./NavbarItems.vue?vue&type=style&index=0&id=2139ae97&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2139ae97"]])

export default __exports__